export default Object.freeze({
  CONNECTING: 'connecting',
  CLOSED: 'closed',
  OPEN: 'open',
  PENDING: 'pending',
});



// WEBPACK FOOTER //
// ./src/scripts/domain/models/phone_connection_status.js